<template>
  <div class="gb-zm-cta-wrapper"
       v-if="availableTrees && availableTrees.length > 0">
    <transition name="fade">
      <div class="gb-zm-cta" v-if="ctaIsVisible === 'on' ">
        {{ label }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CTA',
  props: {
    label: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      ctaIsVisible: 'off'
    }
  },
  computed: {
    availableTrees () {
      return this.$store.getters.availableTrees
    }
  },
  created () {
    localStorage.setItem('chawgtCtaIsVisible', 'off')
    window.setTimeout(() => {
      if (this.$store.getters.needCta === true) {
        localStorage.setItem('chawgtCtaIsVisible', 'on')
      }
    }, this.$store.getters.showCtaDelay * 1000)
    window.setTimeout(() => {
      localStorage.setItem('chawgtCtaIsVisible', 'off')
    }, this.$store.getters.hideCtaDelay * 1000)

    window.setInterval(() => {
      this.ctaIsVisible = localStorage.getItem('chawgtCtaIsVisible')
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

.gb-zm-cta {
  font-family: Roboto, "Helvetica Neue", Arial, sans-serif;
  background: #fff;
  color: #000;
  border-radius: 24px 24px 12px 24px;
  bottom: 20px;
  box-shadow: 0 5px 10px 0 rgba(85,108,131,0.6);
  padding: 13px;
  position: fixed;
  right: 100px;
  width: 140px;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 18px;
  z-index: 9999;
}
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
  transform: translateX(-20px);
}
</style>
